import { lazy, Suspense } from 'react'

import Helmet from 'react-helmet'
import { useSelector } from 'react-redux'

import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export const BUDGET_CATEGORY_CREATE_PAGE = '/settings/budget-categories/create'
export const BUDGETS_CREATE_PAGE = '/settings/budgets/create'

const BudgetCategoryCreateChunk = lazy(() =>
  import('../containers/BudgetCategoryUpsertView').then(
    ({ BudgetCategoryUpsertView }) => ({
      default: BudgetCategoryUpsertView,
    })
  )
)

export const BudgetCategoryCreatePage = () => {
  const intl = useProcurifyIntl()
  const { enable_flexible_spend_tracking: isFlexibleSpendTrackingEnabled } =
    useSelector(makeSelectFeatureSwitches())

  return (
    <Suspense fallback={null}>
      <Helmet>
        <title>
          Procurify |{' '}
          {intl.formatMessage(
            isFlexibleSpendTrackingEnabled
              ? messages.createBudgetTitle
              : messages.createBudgetCategoryTitle
          )}
        </title>
      </Helmet>
      <BudgetCategoryCreateChunk />
    </Suspense>
  )
}
